import React    from "react";
import { Box }  from "@mui/material";
import RoleCard from "../RoleCard";

// accent keys now map to new brand colors from the updated theme
const APP_CARDS = [
  {
    id:         "RESOURCE_ALLOCATION",
    badge:      "Resource Allocation",
    title:      "Resource Allocation",
    desc:       "Manage resource allocation across positions, associates and SOWs. Full visibility into bench pool, FTE utilization and allocation status flow.",
    accentKey:  "accent",
    accent2Key: "accent2",
  },
  {
    id:          "DEMAND_SUPPLY",
    badge:       "Demand Supply",
    title:       "Demand Supply",
    desc:        "Track and plan upcoming resource demand across MACs and SOWs. Forecast headcount requirements and manage open position pipeline.",
    accentKey:   "gold",
    accent2Key:  "gold2",
    comingSoon:  true,
  },
  {
    id:          "CRM",
    badge:       "CRM",
    title:       "CRM",
    desc:        "Manage client relationships, track engagements and maintain a unified view of accounts across delivery units and project portfolios.",
    accentKey:   "steel",
    accent2Key:  "steel2",
    comingSoon:  true,
  },
  {
    id:         "INVESTMENT_LEAGUE",
    badge:      "Investment League",
    title:      "Investment League",
    desc:       "Track portfolio performance, holdings and jackpot eligibility across the PSIOG Capital Growth League.",
    accentKey:  "accent",
    accent2Key: "accent2",
  },
];

const RoleCardGrid = ({ onCardClick }) => {
  return (
    <Box
      sx={{
        display:             "grid",
        gridTemplateColumns: "repeat(4, 280px)",
        gap:                 "16px",
        "@media (max-width: 960px)": {
          gridTemplateColumns: "1fr",
          maxWidth:            "340px",
          width:               "100%",
        },
      }}
    >
      {APP_CARDS.map((card) => (
        <RoleCard
          key={card.id}
          card={card}
          onClick={onCardClick}
        />
      ))}
    </Box>
  );
};

export default RoleCardGrid;
